var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDialog = function SvgDialog(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.534,
    height: 18,
    "data-name": "Component 1 \\u2013 1",
    viewBox: "0 0 18.534 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4aac9c",
    d: "M1 18a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h16.534a1 1 0 0 1 1 1v13.6a1 1 0 0 1-1 1h-13.3l-2.589 2.167A1 1 0 0 1 1 18M2 2v12.858l1.225-1.025a1 1 0 0 1 .642-.234h12.667v-11.6Zm10.166 4.133a1 1 0 0 0-1-1H5.5a1 1 0 0 0 0 2h5.667a1 1 0 0 0 1-1ZM13.499 9.8a1 1 0 0 0-1-1h-7a1 1 0 0 0 0 2h7a1 1 0 0 0 1.001-1Z",
    "data-name": "Path 27"
  })));
};
export default SvgDialog;